import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../store/services/user.service';
import { IUserSessionData } from '../../../store/models/user.model';
import { UtilitiesService } from '../../../store/services/utilities.servive';
import { ISelectItem } from '../../../store/models/select.model';
import { TagsService } from '../../../store/services/tags.service';
import { ITag } from '../../../cos/tags.model';

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss'],
})
export class EditAccountComponent implements OnInit {
  inputForm: FormGroup;

  accountId: number;

  componentReady: boolean;
  states: ISelectItem[] = [];
  countries: ISelectItem[];
  tags: ITag[] = [];


  constructor(
    private readonly userService: UserService,
    private readonly utilService: UtilitiesService,
    private readonly tagsService: TagsService,
  ) {
  }

  get tagItems(): ISelectItem[] {
    return this.tags.map(t => ({
      label: t.name,
      value: t.name,
    }));
  }

  ngOnInit(): void {
    this.tagsService.getTags().subscribe(tags => this.tags = tags.items);
    if (this.accountId) {
      this.userService
        .getAccountInf(this.accountId)
        .subscribe((result: IUserSessionData) => {
          if (result) {
            this.inputForm.addControl(
              'email',
              new FormControl(result.email, [
                Validators.required,
                Validators.email,
              ]),
            );
            this.inputForm.addControl(
              'first_name',
              new FormControl(result.first_name, [Validators.required]),
            );
            this.inputForm.addControl(
              'last_name',
              new FormControl(result.last_name, []),
            );
            this.inputForm.addControl(
              'address1',
              new FormControl(result.address1, [Validators.required]),
            );
            this.inputForm.addControl(
              'address2',
              new FormControl(result.address2, []),
            );
            this.inputForm.addControl('city', new FormControl(result.city, []));
            this.inputForm.addControl('zip', new FormControl(result.zip, []));
            this.inputForm.addControl(
              'phone_number',
              new FormControl(result.phone_number, []),
            );
            this.inputForm.addControl('state', new FormControl(result.state, [Validators.required]));
            this.inputForm.addControl('country', new FormControl(result.country, Validators.required));
            this.countries = Object.keys(this.utilService.getCountries()).map(
              country => {
                return {
                  label: this.utilService.getCountries()[country],
                  value: country,
                };
              },
            );
            this.inputForm.addControl('cos', new FormControl(result.cos, []));
            this.inputForm.addControl('franchis_number', new FormControl(result.franchis_number, []));
            this.onCountrySelect(result.country);
            this.componentReady = true;
          }
        });
    }
  }

  onCountrySelect(value: string) {
    const states = this.utilService.getStates();

    if (states[value]) {
      this.states = Object.keys(states[value]).map(state => {
        return {
          label: states[value][state],
          value: state,
        };
      });
    }
  }
}
